import { createAction } from 'redux-actions';
import { compose } from 'ramda';

import {
  APP_STORE_NAVIGATED,
  FEED_PANEL_SELECTED,
} from 'app/features/success/actionTypes';
import { getParsedSelectedSku } from 'app/router/selectors';
import {
  FREE_TRIAL_SKUS_ARRAY,
  LENGTH_OF_FREE_TRIAL,
  SUBSCRIPTION_SKUS_ARRAY,
} from 'app/constants/freeTrial';
import {
  freeTrialStarted,
  subscriptionStarted,
} from 'app/features/products/actions';
import { fetchWatchlistItems } from 'app/features/watchlist/actions';
import { seriesFetched } from 'app/features/series/actions';

const feedPanelSelected = createAction(FEED_PANEL_SELECTED);
const appStoreNavigated = createAction(APP_STORE_NAVIGATED);

function handleSubscriptionTrackEvents({
  lengthOfFreeTrial = LENGTH_OF_FREE_TRIAL,
} = {}) {
  return (dispatch, getState) => {
    const selectedSku = getParsedSelectedSku(getState());

    if (FREE_TRIAL_SKUS_ARRAY.includes(selectedSku)) {
      dispatch(freeTrialStarted({ sku: selectedSku, lengthOfFreeTrial }));
    } else if (SUBSCRIPTION_SKUS_ARRAY.includes(selectedSku)) {
      dispatch(subscriptionStarted({ sku: selectedSku }));
    }
  };
}

function fetchSeriesWithWatchListItems() {
  return (dispatch, _, { api }) =>
    api
      .fetchSeries()
      .then(compose(dispatch, seriesFetched))
      .then(compose(dispatch, fetchWatchlistItems));
}

export {
  handleSubscriptionTrackEvents,
  feedPanelSelected,
  appStoreNavigated,
  fetchSeriesWithWatchListItems,
};
